import type { LocationData } from '@/types'

export const LOCATION_DATA: Record<string, LocationData> = {
  Northland: { lat: -35.7251, lng: 174.3237, multiplier: 1.05, priceMult: 1.0 },
  Auckland: { lat: -36.8485, lng: 174.7633, multiplier: 1.05, priceMult: 1.02 },
  Waikato: { lat: -37.787, lng: 175.2793, multiplier: 1.0, priceMult: 1.0 },
  'Bay of Plenty': { lat: -37.858, lng: 176.666, multiplier: 1.1, priceMult: 1.0 },
  Gisborne: { lat: -38.6623, lng: 178.0176, multiplier: 1.12, priceMult: 1.0 },
  "Hawke's Bay": { lat: -39.4928, lng: 176.912, multiplier: 1.1, priceMult: 1.0 },
  Taranaki: { lat: -39.0556, lng: 174.0752, multiplier: 1.0, priceMult: 1.0 },
  'Manawatu-Wanganui': { lat: -40.3523, lng: 175.6082, multiplier: 1.0, priceMult: 1.0 },
  Wellington: { lat: -41.2865, lng: 174.7762, multiplier: 0.95, priceMult: 1.12 },
  Tasman: { lat: -41.3262, lng: 172.9644, multiplier: 1.15, priceMult: 1.0 },
  Nelson: { lat: -41.2706, lng: 173.284, multiplier: 1.15, priceMult: 1.0 },
  Marlborough: { lat: -41.5134, lng: 173.9612, multiplier: 1.15, priceMult: 1.0 },
  'West Coast': { lat: -42.4497, lng: 171.2062, multiplier: 0.85, priceMult: 1.0 },
  Canterbury: { lat: -43.5321, lng: 172.6362, multiplier: 1.12, priceMult: 0.98 },
  Otago: { lat: -45.8742, lng: 170.5036, multiplier: 0.95, priceMult: 1.0 },
  Southland: { lat: -46.4132, lng: 168.3538, multiplier: 0.85, priceMult: 1.0 },
  Custom: { lat: -41.0, lng: 174.0, multiplier: 1.0, priceMult: 1.0 },
  Hamilton: { lat: -37.787, lng: 175.2793, multiplier: 1.0, priceMult: 1.0 }, // Legacy support
}

export type LocationKey = keyof typeof LOCATION_DATA
